import { render, staticRenderFns } from "./ShortBtn.vue?vue&type=template&id=81c3323a&scoped=true"
import script from "./ShortBtn.vue?vue&type=script&lang=js"
export * from "./ShortBtn.vue?vue&type=script&lang=js"
import style0 from "./ShortBtn.vue?vue&type=style&index=0&id=81c3323a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3323a",
  null
  
)

export default component.exports